































import Vue from "vue";
import Component from "vue-class-component";
import * as QRCode from "qrcode";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "checkin",
})
export default class Checkin extends Vue {
    qrDataUrl: string = null;

    async mounted() {
        await this.generateQrCode();
        // setInterval(this.generateQrCode, 10000);
    }

    async generateQrCode() {
        this.qrDataUrl = await QRCode.toDataURL(
            JSON.stringify({
                office: this.$route.params.officeId,
                // time: +new Date(),
            }),
            {
                width: 500,
                errorCorrectionLevel: "medium",
            },
        );
    }
}
